import type { StatementsConfig } from '../StatementsConfig';

export const statements: StatementsConfig = {
    enabled: false,
    mode: 'always',
    createStatement: false,
    tableColumns: [
        {
            id: 'date',
            labelKey: 'account.buildingSociety.statements.yearColumn',
            labelize: true,
            header: true,
            width: '30%',
        },
        {
            id: 'period',
            labelKey: 'account.buildingSociety.statements.billingPeriod',
            labelize: true,
            header: true,
            width: '45%',
        },
        {
            id: 'balance',
            labelKey: 'account.buildingSociety.statements.balance',
            labelize: true,
            header: true,
            width: '15%',
        },
        {
            id: 'download',
            labelKey: '',
            labelize: false,
            header: true,
            width: '10%',
        },
    ],
    statementsDelivery: {
        displayDeliveryChangeCard: false,
    },
    downloadRequestType: 'POST',
};
